<template>
  <v-card flat style="margin: 1px 0;" @click="onClick">
    <v-layout row wrap>
      <v-flex xs8 md9 style="text-align:left;padding:10px;">
        <div style="font-size:110%;font-weight:bold;" class="primary--text">
          {{shopname}}
        </div>
        <div>
          <p>{{genre}}</p>
          <p style="margin:0">{{areaText}}</p>
        </div>
      </v-flex>
      <v-flex xs4 md3 style="display: table;min-height:120px;">
        <v-img v-if="isImage" :src="imageurl" max-height="200px" max-width="200px"/>
        <div v-else style='display: table-cell;vertical-align: middle;padding:10px;font-size:16pt;font-family: "游明朝", YuMincho, "ヒラギノ明朝 ProN W3", "Hiragino Mincho ProN", "HG明朝E", "ＭＳ Ｐ明朝", "ＭＳ 明朝", serif;' class="primary white--text">
          {{shop.form.pickMenu}}
        </div>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
export default {
  name: 'ShopCard',
  data () {
    return {
    }
  },
  props: {
    shop: Object,
    images: Array
  },
  computed: {
    isImage () {
      if (this.shop.basic.imageurl !== '') return true
      if (this.shop.form) {
        if (this.shop.form.pickMenu !== '') {
          return false
        }
      }
      return true
    },
    imageurl () {
      return this.shop.basic.displayImage
    },
    shopname () {
      return this.shop.basic.name
    },
    genre () {
      return this.shop.basic.genre
    },
    areaText () {
      let a = this.shop.basic.area
      if (a.m !== '') {
        return `${a.m} ${a.s}`
      } else {
        return ''
      }      
    }
  },
  filters: {
    textTrim: function (value, max) {
      if (value.length >= max) return value.substring(0, max - 1) + '...'
      return value
    }
  },
  mounted () {
  },
  methods: {
    onClick () {
      this.$emit('onShopCardClick', this.shop)
    }
  },
  components: {
  }
}
</script>

<style scoped>
</style>